module.exports = __webpack_public_path__ + "static/media/mystery-boxes-nft-ssr02.74caac32.png";